import React from 'react';
import { Nullable } from 'global';
import { Button, Stack } from '@mui/material';
import { Save, HighlightOff, ControlPoint } from '@mui/icons-material';
import { ScorecardCriteria } from './api';

interface Props {
  scorecardCriteria: Nullable<ScorecardCriteria>;
  onSubmit: () => void;
  onActivateDeactivate: () => void;
}

export const ActionPanel = ({ scorecardCriteria, onSubmit, onActivateDeactivate }: Props) => {
  return (
    <Stack direction="row" justifyContent="flex-end" gap="1rem">
      {scorecardCriteria?.prescreenCriteriaId && (
        <Button
          variant="contained"
          loadingPosition="start"
          color={scorecardCriteria.active ? 'error' : 'success'}
          startIcon={scorecardCriteria.active ? <HighlightOff /> : <ControlPoint />}
          onClick={onActivateDeactivate}
        >
          {scorecardCriteria.active ? 'Deactivate' : 'Activate'}
        </Button>
      )}
      <Button variant="contained" startIcon={<Save />} loadingPosition="start" onClick={onSubmit}>
        {scorecardCriteria?.prescreenCriteriaId ? 'Update ' : 'Save'}
      </Button>
    </Stack>
  );
};
